<template>
    <v-card
        class="mx-auto overflow-visible my-2"
        width="400px"
        outlined
    >
        <v-list-item three-line>
            <validation-observer v-slot="{ handleSubmit }">
                <v-list-item-content class="overflow-visible">
                  <v-row style="width: 100%; padding: 0px 20px">
                    <v-autocomplete
                        v-model="filterForm.store"
                        :items="stores"
                        item-text="name"
                        item-value="value"
                        label="Chọn kho"
                        placeholder="Chọn kho"
                        clearable
                    />
                  </v-row>
<!--                  <v-row style="width: 100%; padding: 0px 20px">-->
<!--                    <v-text-field-->
<!--                        type="number"-->
<!--                        min="0"-->
<!--                        step="1"-->
<!--                        label="Số lượng contact được phân bổ"-->
<!--                        placeholder="Nhập số lượng contact được phân bổ"-->
<!--                        v-model="filterForm.number_of_contact"-->
<!--                        clearable-->
<!--                        @keyup.enter.native="handleSubmit(searchUser)">-->
<!--                    </v-text-field>-->
<!--                  </v-row>-->
                  <v-row style="width: 100%; padding: 0px 20px">
                    <v-text-field
                      label="Nhân viên"
                      placeholder="Nhập tên nhân viên"
                      v-model="filterForm.name"
                      @keyup.enter.native="handleSubmit(searchUser)">
                    </v-text-field>
                  </v-row>
                  <v-row style="width: 100%; padding: 0px 20px">
                    <v-autocomplete
                        v-model="filterForm.allotmentId"
                        color="primary"
                        no-data-text="Không có dữ liệu"
                        :items="allotmentList"
                        item-text="name"
                        item-value="id"
                        label="Lộ trình"
                        placeholder="Chọn lộ trình"
                        clearable
                    />
                  </v-row>
                    <div class="text-center">
                        <v-btn class="mx-0"
                             color="rgba(43, 1, 132, 0.5)"
                             @click.prevent="handleSubmit(searchUser)">
                          <v-icon>mdi-magnify</v-icon>Tìm kiếm
                        </v-btn>
                    </div>
                </v-list-item-content>
            </validation-observer>
        </v-list-item>
    </v-card>
</template>

<script>
import TokenService from "@/helpers/token";
import RepositoryFactory from "@/repositories/RepositoryFactory";
const DepartmentRepository = RepositoryFactory.get('department')

export default {
  props: {
    filterForm: {
      type: Object,
      default: () => {}
    },
    listSchoolLevel: {
      type: Array,
      default: () => {[]}
    },
    listType: {
      type: Array,
      default: () => {[]}
    },
    allotmentList: {
      type: Array,
      default: () => {[]}
    }
  },
  data() {
    return {
      stores: [
        {
            name: 'Kho T',
            value: 'T'
        },
        {
            name: 'Kho C',
            value: 'C'
        },
        {
          name: 'Kho M',
          value: 'M'
        }
      ],
      departmentList: [],
      errors: []
    }
  },
  methods: {
    searchUser() {
      Bus.$emit('search-user-allotment-contact', this.filterForm)
    }
  }
}
</script>